// extracted by mini-css-extract-plugin
export default {"list":"pWUz3U5WZT","listItem":"c03PfMxKZs"};